<template>
  <div class="pa-6">
    <v-container fluid>
      <v-row>
        <v-col>
          <h2 class="primary--text">{{ $t(pageTitle) }}</h2>
        </v-col>
        <!-- CSVから一括出庫 -->
        <slot name="bulkCsvShip" />
      </v-row>
      <v-row>
        <v-col>
          <!-- 履歴検索 -->
          <ExpansionPanel :open="true">
            <template #header>
              <SearchHeaderArea
                class="px-9"
                v-model="searchHeaderInfo"
                :checkboxLabel="searchHeaderInfo.checkboxLabel"
              />
            </template>
            <template #content>
              <slot name="searchDetailArea" />
            </template>
          </ExpansionPanel>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <!-- 履歴一覧 -->
          <slot name="historyList" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import ExpansionPanel from '@/components/items/Designs/ExpansionPanel'
import SearchHeaderArea from '@/components/items/Designs/SearchHeaderArea'

// import { ExpansionPanel, SearchHeaderArea } from '@/components/items'

export default {
  components: {
    ExpansionPanel,
    SearchHeaderArea
  },
  props: {
    pageTitle: {
      type: String,
      require: true,
      default: ''
    },
    searchHeaderInfo: {
      productName: '',
      InvalidData: true,
      checkboxLabel: ''
    }
  },
  data: () => ({
    //
  }),
  watch: {
    'searchHeaderInfo.InvalidData': async function (val) {
      this.$emit('changeInvalid', val)
    },
    'searchHeaderInfo.productName': async function (val) {
      this.$emit('changeProductName', val)
    }
  }
}
</script>
<style scoped lang="scss"></style>
